import {ReactNode, useState} from "react";
import {FaRegEye} from "react-icons/fa6";

import {ButtonAction, QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {AuditLogChange} from "@/lib/types/auditlogs.ts";
import {AuditLogViewModal} from "@/pages/auditlog/list/components/AuditLogViewModal.tsx";

type AuditLogActionProps = {
  id: number;
  objectString: string;
  changes: AuditLogChange[];
  modelDisplay: string;
};

export const AuditLogActions = ({id, objectString, changes, modelDisplay}: AuditLogActionProps) => {
  const [showViewModal, setShowViewModal] = useState<boolean>(false);

  // Disable view action for Auth entries and entries with no field changes (e.g. notification-sent log lines)
  const hasNoChanges = !changes || changes.length === 0;
  const isAuthEntry = modelDisplay === "Auth";

  const actions: ReactNode[] =
    isAuthEntry || hasNoChanges
      ? []
      : [
          <ButtonAction tooltip="View" onClick={() => setShowViewModal(true)}>
            <FaRegEye />
          </ButtonAction>,
        ];
  return (
    <>
      {showViewModal && (
        <AuditLogViewModal
          objectString={objectString}
          changes={changes}
          showViewModal={showViewModal}
          setShowViewModal={setShowViewModal}
        />
      )}
      <QuickActionsBar id={`audit-log-action-${id}`} actions={actions} />
    </>
  );
};
